<template>
  <section id="Preise" class="py-5 bg-white text-dark">
    <div class="container pb-5">
      <div class="row mx-md-auto col-md-8 mt-5">
        <div class="col-12 text-center ">
          <h2 class="mb-5" data-aos="fade-up" data-aos-delay="500">Preise und Pakete</h2>
          <p class="text-dark" data-aos="fade-up" data-aos-delay="500">Für eine bessere Übersicht habe ich Pakete zusammengestellt, welche für die meisten Veranstaltungen geeignet sind.</p>
          <p class="text-dark" data-aos="fade-up" data-aos-delay="500">Sie suchen einen DJ für Ihre Hochzeit, Ihre Geburtstagsfeier, ein Firmenevent oder eine sonstige Veranstaltung?</p>
          <p class="text-dark" data-aos="fade-up" data-aos-delay="500">Sie möchten mal wieder so richtig feiern? Dem Anlass entsprechend passe ich mich Ihrer Veranstaltung an!</p>
          <p class="text-dark" data-aos="fade-up" data-aos-delay="500">Sie bekommen eine exzellente Auswahl an hochwertige Technik von namhaften Markenherstellern sowohl bei der Ton- als auch bei der Lichttechnik.</p>
          <p class="text-dark" data-aos="fade-up" data-aos-delay="500">Mein ganzes Konzept ist ausgelegt auf höchste Kundenzufriedenheit im Hinblick auf Dienstleistung, Qualität und faire Preise.</p>
        </div>
      </div>

      <div class="row g-5 my-5">
        <div class="col-xl-4" data-aos="fade-up" data-aos-delay="500">
          <div class="h-100 w-100 rounded-2 p-4 shadow text-white" style="background: var(--bs-indigo);">
            <h3 class="mb-5 text-center">Hochzeits DJ Standard</h3>
            <p>Ab 17 Uhr bis 24 Uhr<br>(Verlängerungsstunde möglich)</p>
            <p>Ausführliches Kennenlerngespräch</p>
            <p>Auf- und Abbau der Musik- und Lichtanlage</p>
            <p>Ein professionelles Kabelmikrofon</p>
            <p>Ausreichendes Lichtequipment auf LED-Beleuchtungsbasis</p>
            <p>Professionelles Tonequipment bis max. 50 Gäste</p>
            <p>An- & Abfahrt inkl. 75km Hin- und Rückfahrt</p>
          </div>
        </div>

        <div class="col-xl-4" data-aos="fade-up" data-aos-delay="500">
          <div class="h-100 w-100 rounded-2 p-4 shadow text-white" style="background: var(--bs-purple);">
            <h3 class="mb-5 text-center">Hochzeits DJ Premium</h3>
            <p>Ab 17 Uhr bis 24 Uhr<br>(Verlängerungsstunde möglich)</p>
            <p>Ausführliches Kennenlerngespräch</p>
            <p>Auf- und Abbau der Musik- und Lichtanlage</p>
            <p>Ein professionelles Kabel- & Funkmikrofon (Reden/Spiele)</p>
            <p>Ausreichendes Lichtequipment auf LED-Beleuchtungsbasis inkl. 2 Movingheads</p>
            <p>Professionelles Tonequipment max. 120 Gäste</p>
            <p>An- & Abfahrt inkl. 75km Hin- und Rückfahrt</p>
          </div>
        </div>

        <div class="col-xl-4" data-aos="fade-up" data-aos-delay="500">
          <div class="h-100 w-100 rounded-2 p-4 shadow text-white" style="background: var(--bs-pink);">
            <h3 class="mb-5 text-center">Event DJ</h3>
            <p>Geburtstage, Firmenevent, Veranstaltung und Partys aller Art</p>
            <p>Der Preis ist gestaffelt nach:</p>
            <ul>
              <li>Dauer und Art des Events</li>
              <li>Anzahl der Gäste</li>
              <li>Einsatz von Technik (Licht-/Effektanlagen)</li>
              <li>Entfernung zum Einsatzort</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row text-center pt-5">
        <div class="col-12">
          <h2 class="mb-5" data-aos="fade-up" data-aos-delay="500">Ihre Vorteile auf einen Blick:</h2>
          <p class="text-dark" data-aos="fade-up" data-aos-delay="500">Sie bekommen eine absolute Preistransparenz durch 3 Paketpreise ohne Überraschungen</p>
          <p class="text-dark" data-aos="fade-up" data-aos-delay="500">Zuverlässig, erlesene Musikauswahl, Erfahrung, hochwertige Technik, freundlich und vorbereitet</p>
          <p class="text-dark" data-aos="fade-up" data-aos-delay="500">Mein ganzes Konzept ist ausgelegt auf höchste Kundenzufriedenheit im Hinblick auf Dienstleistung, Qualität und faire Preise</p>
          </div>
      </div>
    </div>
  </section>
</template>

<script>
</script>

<style scoped>
.shadow {
  transition: 0.5s;
}
.shadow:hover {
  transform: scale(105%);
}
</style>